import React from 'react';
import { observer } from "mobx-react";
import { HashRouter as Router, Route} from "react-router-dom";
import { Layout, Card, Row, Col} from 'antd';
import MainView from './components/views/MainView';
import InputMenus from "./components/menus/InputMenus"
import TranslationsView from './components/views/TranslationsView'
import {AccessibilityView} from "./components/menus/Accessibility"
import ModeMenus from './components/menus/ModeMenus'
import 'antd/dist/antd.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './App.css';
import './americanSearch.css';
import Store from './stores/Store';
import CSUSLogoImg from './resources/CSUS english logo.jpg';
import { translateText, getDirection } from './stores/objects/I18n'
import ReactGA from 'react-ga';


const { Content, Sider, Header } = Layout;

const Home = observer(class Home extends React.Component{
  
  constructor(props, context){
     super(props, context);
     this.isMobile = this.mobilecheck();    
     this.store = new Store(props);
     this.inputRef  = React.createRef();
     this.mainResultsRef  = React.createRef();
     ReactGA.initialize("UA-188523007-1"); 
  }

  mobilecheck = () => {
    var check = false;
    //eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  render() {

    

    ReactGA.pageview(window.location.pathname + window.location.search);
    if(this.isMobile) {
      return (<Card style={{textAlign: "center"}}>
        Sorry, the search engine is not supported on mobile
      </Card>)
    }

    let headerText = this.store.searchExists ? 
      translateText(this.store, "Results") : 
      translateText(this.store, "Welcome to the Center for the Study of the US search engine");
    return (
    <section className={"CSUS-SE-"+getDirection(this.store)+
                   (this.store.state.accessibilityEnabled ? " CSUS-SE-accessible" : "")}>
    <Layout style={{minHeight: '100vh'}}>
        <Sider width="25vw" className="CSUS-SE-sider">
          <Row style={{width: "100%",
                                  margin: "0px",
                                  textAlign: "center"}}>
          
          <img
                src={CSUSLogoImg}
                alt="Tel Aviv University Center for the Study of the United States logo"
                style={{height: "40px", margin: "12px"}}/>
          </Row>
          <InputMenus store={this.store} inputRef={this.inputRef}/>
        </Sider>
      <Layout style={{ minWidth: '100vh'}}>
        <Header className="CSUS-SE-header" style={{paddingLeft: "1rem", paddingRight: "1rem"}}>
          <Row type='flex'>
            <Col span={16} order={1}>
                <h1 style={{ fontSize: "20px"}}>{headerText}</h1>
            </Col>
            <Col span={8} order={2}>
            <ModeMenus store={this.store} inputRef={this.inputRef} />
            </Col>
          </Row>
        </Header>
        <Content> 
          <Row>
            <Col
              span={24}
              style={{height: "calc(100vh - 90px)"}}>
                <div style={{width: "100%", height: "100%"}}>
                  <AccessibilityView store={this.store}/>
                  <TranslationsView store={this.store} />
                  <MainView store={this.store}/>
                </div>
                
            </Col>
          </Row>
        </Content>
        <footer>
          <div className="CSUS-SE-footer" direction="ltr"> Copyright 2019-2020, Or Rappel-Kroyzer, CSUS, Tel-Aviv University &copy;</div>
        </footer>
      </Layout>
    </Layout>
    </section>
  );
}

});


class App extends React.Component{

  constructor(props, context){
    super(props, context);
    console.log('v 0.0.1')
  }

  render(){
    return(
      <Router>
        <Route
          path="/*"
          exact
          render={props => <Home {...props}/>}/>
      </Router>
    )
  }
}

export default App;

